module.exports = __webpack_public_path__ + "static/media/menu.8523ee27.svg";